import type { SVGProps } from 'react';
const SvgHomeRepairService = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#home_repair_service_svg__a)">
      <path d="M18 16h-2v-1H8v1H6v-1H2v5h20v-5h-4v1ZM20 8h-3V6c0-1.1-.9-2-2-2H9c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v4h4v-2h2v2h8v-2h2v2h4v-4c0-1.1-.9-2-2-2Zm-5 0H9V6h6v2Z" />
    </g>
    <defs>
      <clipPath id="home_repair_service_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgHomeRepairService;
